import { CGM_POLICY } from "./cgm.ts";
import type { AgencyPolicy } from "./policy.ts";

export { CGM_POLICY } from "./cgm.ts";
export {
  type AgencyPolicy,
  type AgencyRule,
  applyAgencyPolicy,
  dayIn,
  type PolicyNote,
  policyText,
  type RuleStage,
} from "./policy.ts";

/**
 * The agency this system serves. A deployment is one agency's system (docs/vision.md), and dev runs
 * CGM's policy too, so it tests what prod runs. Phase 1 (#186) reads the policy from the agency's
 * data, by partner, instead.
 */
export const AGENCY_POLICY: AgencyPolicy = CGM_POLICY;
